module.exports = __webpack_public_path__ + "img/logo-sm-white.5b870054.svg";